const songs = [
  {
    title: 'Work From Home',
    duration: '03:35'
  }, {
    title: 'Perfect',
    duration: '04:20'
  }, {
    title: 'Girls Like You',
    duration: '03:16'
  }, {
    title: 'Starboy',
    duration: '03:18'
  }, {
    title: 'Love Me Like You Do',
    duration: '05:55'
  },
];

export default songs;
